import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {AnalyticsDashboardPage} from './pages/AnalyticsDashboardPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";

// Single-page module today: analytics has one dashboard and no add/edit pages.
// It still uses the module/* layout shape so the route carries its own RBAC gate
// (GetAnalytics) rather than relying on the navbar to hide the link (FNP-1119).
export const AnalyticsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.GetAnalytics) ? (
                        <AnalyticsDashboardPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
        </Routes>
    );
};
